import { AuctionHouse } from '@metaplex-foundation/mpl-auction-house';
import { getAccountParsingFunction } from '../../../types/Account.mjs';

const parseAuctionHouseAccount = getAccountParsingFunction(AuctionHouse);

export { parseAuctionHouseAccount };
//# sourceMappingURL=AuctionHouseAccount.mjs.map
